var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLhPrintActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.708 38.7044V12.0114L23.6024 20.3397V46.7047C23.6024 46.7047 22.8945 52.5522 33.3012 56.9117L53 48.74C53 48.74 43.708 45.1423 43.708 38.7041V38.7044Z",
    fill: "#4AAC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6021 20.3398L41.412 12.9624L43.708 12.0114L40.1059 10.0002L20.0002 18.3282V28.5911L23.6021 30.0831V20.3398Z",
    fill: "#10260F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3152 56.906L33.3012 56.9117C22.8945 52.5522 23.6024 46.7048 23.6024 46.7048V33.4097L20.0005 31.9178V45.6132L13 48.513L33.3155 56.9279V56.906H33.3152Z",
    fill: "#10260F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6985 18.7571L26.2598 25.2058V23.3367L41.6985 16.888V18.7571Z",
    fill: "#10260F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6985 23.8533L26.2598 30.3019V28.4331L41.6985 21.9844V23.8533Z",
    fill: "#10260F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6985 28.9496L26.2598 35.3983V33.5292L41.6985 27.0805V28.9496Z",
    fill: "#10260F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6985 34.0457L26.2598 40.4944V38.6253L41.6985 32.1766V34.0457Z",
    fill: "#10260F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6985 39.142L26.2598 45.5904V43.7216L41.6985 37.2729V39.142Z",
    fill: "#10260F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4248 43.7416L27.9863 50.1903L27.1213 48.774L42.56 42.3253L43.4248 43.7416Z",
    fill: "#10260F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2355 47.5733L31.797 54.022L29.9921 52.9474L45.4308 46.4987L47.2355 47.5733Z",
    fill: "#10260F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhPrintActive);
export default __webpack_public_path__ + "static/media/LH-Print-active.d054acc60d58db461655728932700623.svg";
export { ForwardRef as ReactComponent };